import { c as _c } from "react/compiler-runtime";
import { addHours, startOfHour, subDays } from 'date-fns';
import { Form, Formik } from 'formik';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';
import useSWR from 'swr';
import { SeekPagination } from '../../../../../../../typings/API.interface';
import { Transformation } from '../../../../../../../typings/Transformation.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { formatNumberShorthand } from '../../../../utils';
import field_formats from '../../../../utils/field-formatters';
import { cleanseFormErrorObject } from '../../../../utils/form';
import formatMetricsQuery from '../../../../utils/formatMetricsQuery';
import Button from '../../../common/base/Button';
import { StyledCardSection } from '../../../common/base/Card';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import Dropdown from '../../../common/Dropdown';
import DropdownMenu from '../../../common/DropdownMenu';
import EmptyState, { EmptyResults, StyledEmptyStateWrapper } from '../../../common/EmptyState';
import TextAreaInput from '../../../common/Form/Fields/TextAreaInput';
import { Div } from '../../../common/helpers/StyledUtils';
import { buildPreviewBuckets, GROUP_METRICS_BY_2H, GROUP_METRICS_BY_4H, PreviewBucket, PreviewMetricEntry } from '../../../common/Histogram/PreviewHistogram';
import PreviewHistogram from '../../../common/Histogram/PreviewHistogram';
import Table from '../../../common/Table/Table';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useMetricsQuery from '../../../hooks/useMetricsQuery';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { TransformationsListQueryParams } from './TransformationsView';
const now = addHours(startOfHour(new Date()), 1);
const TransformationMetricsPreview = t0 => {
  const $ = _c(18);
  const {
    data_2h_sample,
    data_4h_sample,
    transformation
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      successful: {
        color: "green_histogram",
        label: "Successful"
      },
      failed: {
        color: "red_histogram",
        label: "Failed"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dimensions_config = t1 as const;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 72
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data_4h_sample) {
    t3 = (opened, toggle) => <Button ghost={true} p={1.5} w={100} active={opened} onClick={e_0 => {
      e_0.stopPropagation();
      toggle(!opened);
    }}><PreviewHistogram size="small" values={data_4h_sample} dimensions_config={dimensions_config} resolution="hour" /></Button>;
    $[2] = data_4h_sample;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      px: 382
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      b: 2
    };
    t6 = <Text size="s" semi={true}>Transformations</Text>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Div flex={true} m={t5}>{t6}<Text size="s" semi={true} muted={true} m={{
        x: 1
      }}>{" \xB7 "}</Text><Text size="s" semi={true} neutral={true}>Last 24h</Text></Div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== data_2h_sample) {
    t8 = <StyledCardSection p={4} w={t4}>{t7}<PreviewHistogram values={data_2h_sample} resolution="hour" dimensions_config={dimensions_config} show_tooltip={true} size="medium" /></StyledCardSection>;
    $[8] = data_2h_sample;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      x: 4,
      y: 3
    };
    t10 = {
      justify: "flex-end"
    };
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  const t11 = `/transformations/${transformation.id}`;
  let t12;
  if ($[12] !== t11) {
    t12 = <StyledCardSection p={t9} flex={t10}><Button outline={true} to={t11} icon="link">View transformation</Button></StyledCardSection>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12 || $[15] !== t3 || $[16] !== t8) {
    t13 = <Div w={t2} onClick={_temp}><Dropdown placement="bottom-end" portal={true} renderToggle={t3}>{t8}{t12}</Dropdown></Div>;
    $[14] = t12;
    $[15] = t3;
    $[16] = t8;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
};
const TransformationPreview = t0 => {
  const $ = _c(14);
  const {
    transformation,
    mutate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] !== HookdeckAPI.transformations || $[1] !== addToast || $[2] !== mutate || $[3] !== transformation.id) {
    t1 = (values, t2) => {
      const {
        resetForm
      } = t2;
      return HookdeckAPI.transformations.update(transformation.id, {
        name: values.name
      }).then(updated_transformation => {
        resetForm({
          values: {
            name: updated_transformation.name
          },
          touched: {}
        });
        mutate();
        addToast("success", "Transformation name updated");
      }).catch(e => {
        addToast("error", `An error occurred while saving the transformation${e.response?.data[0] ? `: ${e.response.data[0]}` : ""}`);
      });
    };
    $[0] = HookdeckAPI.transformations;
    $[1] = addToast;
    $[2] = mutate;
    $[3] = transformation.id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== HookdeckAPI.transformations || $[6] !== transformation.name) {
    t2 = async values_0 => {
      const errors = {};
      if (!values_0.name || values_0.name.length < 1) {
        errors.name = "Required";
      } else {
        if (values_0.name !== transformation.name) {
          const used = await HookdeckAPI.transformations.nameIsUsed(values_0.name);
          if (used) {
            errors.name = "Name is already used.";
          }
        }
      }
      return cleanseFormErrorObject(errors);
    };
    $[5] = HookdeckAPI.transformations;
    $[6] = transformation.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = transformation.name || "";
  let t4;
  if ($[8] !== t3) {
    t4 = {
      name: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <Formik onSubmit={t1} validate={t2} initialValues={t4}>{_temp2}</Formik>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
const TransformationName = t0 => {
  const $ = _c(11);
  const {
    name,
    transformation,
    mutate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      l: -2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 408
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== name) {
    t4 = (opened, toggle) => <Button ghost={true} active={opened} style={{
      maxWidth: "100%"
    }} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text as="span" mono={true} ellipsis={true}>{name}</Text></Button>;
    $[3] = name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== mutate || $[6] !== transformation) {
    t5 = <TransformationPreview transformation={transformation} mutate={mutate} />;
    $[5] = mutate;
    $[6] = transformation;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Div flex={true} m={t1} min_w={0}><Div onClick={_temp3} style={t2}><Dropdown placement="bottom-start" parent_width={t3} portal={true} renderToggle={t4}>{t5}</Dropdown></Div></Div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
const TransformationConnections = t0 => {
  const $ = _c(27);
  const {
    transformation
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const [is_open, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== transformation.id) {
    t1 = APIMethodKeys.transformations.getConnections(transformation.id);
    $[0] = transformation.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.transformations || $[3] !== transformation.id) {
    t2 = () => HookdeckAPI.transformations.getConnections(transformation.id);
    $[2] = HookdeckAPI.transformations;
    $[3] = transformation.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: transformation_connections
  } = useSWR(t1, t2);
  let t3;
  if ($[5] !== is_open || $[6] !== transformation.id) {
    t3 = is_open && APIMethodKeys.transformations.getConnections(transformation.id);
    $[5] = is_open;
    $[6] = transformation.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== HookdeckAPI.transformations || $[9] !== transformation.id) {
    t4 = () => HookdeckAPI.transformations.getConnections(transformation.id);
    $[8] = HookdeckAPI.transformations;
    $[9] = transformation.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: connections
  } = useSWR(t3, t4);
  const count = transformation_connections?.count || 0;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      l: -2
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = typeof connections === "undefined";
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      min: 300
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== count || $[14] !== history || $[15] !== transformation.id) {
    t8 = (opened, toggle) => <Button ghost={true} active={opened} onClick={e_0 => {
      if (count === 0) {
        history.push("/connections/new?transformation_id=" + transformation.id);
      }
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text muted={count !== 0} neutral={count === 0}>{count === 0 ? "Add " : count}{count > 100 && "+"}{count === 0 && <Icon neutral={true} icon="add_circle" pointer={true} m={{
          l: 1
        }} />}</Text></Button>;
    $[13] = count;
    $[14] = history;
    $[15] = transformation.id;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== history || $[18] !== transformation.id) {
    t9 = () => <Div p={1}><Button w={100} ghost={true} icon="add_circle" onClick={() => {
        history.push("/connections/new?transformation_id=" + transformation.id);
      }}>New connection</Button></Div>;
    $[17] = history;
    $[18] = transformation.id;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== connections?.models) {
    t10 = connections?.models?.map(_temp5) || [];
    $[20] = connections?.models;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t11 = <Div flex={true} m={t5}><Div onClick={_temp4}><DropdownMenu placement="bottom-end" ghost={true} search={true} portal={true} search_is_loading={t6} parent_width={t7} onToggle={setIsOpen} renderToggle={t8} getItemsFooter={t9} options={t10} /></Div></Div>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
const TransformationExecutions = t0 => {
  const $ = _c(13);
  const {
    transformation,
    timeseries_2h_sample,
    timeseries_4h_sample,
    count
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 40
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = count || 0;
  let t4;
  if ($[2] !== t3) {
    t4 = formatNumberShorthand(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <Text w={t2} muted={true} number={true}>{t4}</Text>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== timeseries_2h_sample || $[7] !== timeseries_4h_sample || $[8] !== transformation) {
    t6 = <TransformationMetricsPreview data_2h_sample={timeseries_2h_sample} data_4h_sample={timeseries_4h_sample} transformation={transformation} />;
    $[6] = timeseries_2h_sample;
    $[7] = timeseries_4h_sample;
    $[8] = transformation;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Div flex={t1} min_w={0}>{t5}{t6}</Div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
type Pagination = SeekPagination & {
  page_size: number;
};
const TransformationsList = t0 => {
  const $ = _c(48);
  const {
    transformations,
    total,
    loading,
    pagination,
    mutate,
    filtering
  } = t0;
  const [current_page, setCurrentPage] = useState(1);
  const history = useHistory();
  const theme = useTheme();
  const {
    query: t1,
    updateSearchQuery
  } = useSearchQuery();
  const {
    selected_transformation_id
  } = t1;
  let t2;
  if ($[0] !== transformations) {
    const query_params = {
      filters: {
        date: {
          min: subDays(now, 1).toISOString(),
          max: now.toISOString()
        },
        transformation_id: transformations?.map(_temp6)
      } as any,
      granularity: "hour" as const,
      measure: ["count", "successful_count", "failed_count"],
      dimensions: ["transformation_id"]
    };
    t2 = transformations ? formatMetricsQuery("TransformationExecutions", query_params) : null;
    $[0] = transformations;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const metrics_query = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      resetResultSetOnChange: false
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    raw_data
  } = useMetricsQuery(metrics_query, t3);
  let t4;
  let timeseries_2h_by_transformation_id;
  if ($[3] !== raw_data || $[4] !== transformations) {
    const entries = raw_data?.flatMap(_temp7) ?? null;
    const transformation_ids = transformations.map(_temp8);
    timeseries_2h_by_transformation_id = entries && buildPreviewBuckets(transformation_ids, entries, GROUP_METRICS_BY_2H, now);
    t4 = entries && buildPreviewBuckets(transformation_ids, entries, GROUP_METRICS_BY_4H, now);
    $[3] = raw_data;
    $[4] = transformations;
    $[5] = t4;
    $[6] = timeseries_2h_by_transformation_id;
  } else {
    t4 = $[5];
    timeseries_2h_by_transformation_id = $[6];
  }
  const timeseries_4h_by_transformation_id = t4;
  let t5;
  if ($[7] !== raw_data || $[8] !== transformations) {
    let t6;
    if ($[10] !== raw_data) {
      t6 = (obj, t7) => {
        const {
          id: id_1
        } = t7;
        obj[id_1] = raw_data?.reduce((acc, entry) => {
          if (entry?.["TransformationExecutions.transformation_id"] === id_1) {
            acc = acc + parseInt(entry?.["TransformationExecutions.count"]);
          }
          return acc;
        }, 0);
        return obj;
      };
      $[10] = raw_data;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = transformations.reduce(t6, {});
    $[7] = raw_data;
    $[8] = transformations;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const count_by_transformation_id = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      min: 200
    }, {
      min: 160,
      max: 160
    }, {
      min: 128,
      max: 128
    }];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const widths = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["Transformation Name", "Executions (24h)", "Connections"];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const headers = t7;
  let t8;
  if ($[14] !== count_by_transformation_id || $[15] !== loading || $[16] !== mutate || $[17] !== selected_transformation_id || $[18] !== timeseries_2h_by_transformation_id || $[19] !== timeseries_4h_by_transformation_id || $[20] !== transformations) {
    t8 = loading ? [] : transformations.reduce((rows, transformation) => [...rows, {
      id: transformation.id,
      selected: selected_transformation_id === transformation.id,
      highlighted: selected_transformation_id === transformation.id,
      expendable: false,
      fields: [<TransformationName key={transformation.id} name={transformation.name} transformation={transformation} mutate={mutate} />, <TransformationExecutions key={transformation.id} transformation={transformation} timeseries_2h_sample={timeseries_2h_by_transformation_id?.[transformation.id] || []} timeseries_4h_sample={timeseries_4h_by_transformation_id?.[transformation.id] || []} count={count_by_transformation_id?.[transformation.id] || 0} />, <TransformationConnections key={transformation.id} transformation={transformation} />]
    }], []);
    $[14] = count_by_transformation_id;
    $[15] = loading;
    $[16] = mutate;
    $[17] = selected_transformation_id;
    $[18] = timeseries_2h_by_transformation_id;
    $[19] = timeseries_4h_by_transformation_id;
    $[20] = transformations;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const rows_0 = t8;
  let t9;
  if ($[22] !== history) {
    t9 = id_2 => {
      history.push(`/transformations/${id_2}`);
    };
    $[22] = history;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const onRowSelected = t9;
  if (transformations.length === 0 && !loading) {
    if (filtering) {
      let t10;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <StyledEmptyStateWrapper><EmptyResults label="No transformations found" /></StyledEmptyStateWrapper>;
        $[24] = t10;
      } else {
        t10 = $[24];
      }
      return t10;
    }
    const t10 = `transformations-${theme.mode}.png`;
    let t11;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        label: "Create a transformation",
        icon: "add_circle",
        to: "/transformations/new"
      };
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t12;
    if ($[26] !== t10) {
      t12 = <EmptyState title="Modify event payloads" description="Transformations are a Hookdeck rule that let you use a Javascript function to modify the request body, headers, query, or path before it reaches your endpoint." asset={t10} asset_position="background" cta={t11} />;
      $[26] = t10;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    return t12;
  }
  const t10 = pagination?.page_size || 50;
  let t11;
  if ($[28] !== current_page || $[29] !== t10) {
    t11 = {
      current_page,
      page_size: t10,
      entity_name: "transformations"
    };
    $[28] = current_page;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== current_page || $[32] !== pagination || $[33] !== updateSearchQuery) {
    t12 = pagination?.next ? () => {
      updateSearchQuery({
        next: pagination.next,
        prev: undefined
      });
      setCurrentPage(current_page + 1);
    } : undefined;
    $[31] = current_page;
    $[32] = pagination;
    $[33] = updateSearchQuery;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== current_page || $[36] !== pagination || $[37] !== updateSearchQuery) {
    t13 = pagination?.prev ? () => {
      updateSearchQuery({
        prev: pagination.prev,
        next: undefined
      });
      setCurrentPage(current_page - 1);
    } : undefined;
    $[35] = current_page;
    $[36] = pagination;
    $[37] = updateSearchQuery;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== loading || $[40] !== onRowSelected || $[41] !== rows_0 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== total || $[46] !== transformations.length) {
    t14 = <Div h={100}><Table fill={true} list={true} headers={headers} widths={widths} top_offset={106} rows={rows_0} loading={loading} loading_title="Transformations loading" loading_message="It may take a few moments to populate your transformations." onRowSelected={onRowSelected} pagination={t11} onNextPage={t12} onPreviousPage={t13} current_count={transformations.length} total_count={total} /></Div>;
    $[39] = loading;
    $[40] = onRowSelected;
    $[41] = rows_0;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = total;
    $[46] = transformations.length;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  return t14;
};
export default TransformationsList;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(t0) {
  const {
    dirty,
    resetForm: resetForm_0,
    isSubmitting,
    isValid
  } = t0;
  return <Form><StyledCardSection p={{
      x: 4,
      b: 6
    }}><Div m={{
        t: 4
      }}><TextAreaInput mono={true} name="name" label="Transformation Name" required={true} m={0} auto_resize={true} format={field_formats.slugify} maxlength={155} help="Provide a unique name that represents this transformation." /></Div></StyledCardSection><StyledCardSection p={{
      x: 4,
      y: 3
    }} flex={{
      justify: "flex-end",
      gap: 3
    }}>{dirty && <Button onClick={() => resetForm_0()} outline={true}>Cancel</Button>}<Button submit={true} primary={true} icon="save" disabled={isSubmitting || !isValid}>{isSubmitting ? "Saving..." : "Save"}</Button></StyledCardSection></Form>;
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e) {
  return e.stopPropagation();
}
function _temp5(connection) {
  return {
    label: connection.full_name,
    to: `/connections/${connection.id}`
  };
}
function _temp6(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp7(e) {
  return (["successful", "failed"] as const).map(status => ({
    time: new Date(e["TransformationExecutions.createdAt"]).getTime(),
    count: parseInt(e[`TransformationExecutions.${status}_count`] || "0", 10),
    id: e["TransformationExecutions.transformation_id"],
    dimension: status
  }));
}
function _temp8(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}